{
  "title": "My tasks",
  "subtitle": "Tasks assigned to you across all projects, plus your personal ones",
  "only_pending": "Only pending",
  "record_meeting": "Record meeting",
  "record_meeting_title": "Record personal meeting",
  "create_button": "New task",
  "create_placeholder": "What needs to be done?",
  "create_submit": "Create task",
  "create_creating": "Creating…",
  "create_cancel": "Cancel",
  "create_note": "This task will be personal (no project). You can move it to a project later.",
  "create_error_generic": "Couldn't create the task.",
  "attach_error": "The task was created, but the attachments couldn't be uploaded.",
  "rename_task_title": "Edit name",
  "field_name": "Name",
  "field_priority": "Priority",
  "field_due_date": "Due date",
  "field_team": "Team",
  "team_all": "All teams",
  "team_none": "No team",
  "field_project": "Project",
  "project_none": "Personal (no project)",
  "field_link": "Link",
  "link_placeholder": "https://… (video, document, etc.)",
  "field_attachments": "Attachments (image, video, file)",
  "field_description": "Description",
  "field_assignee": "Assignee",
  "assignee_me": "Me",
  "assignees_search": "Search member…",
  "team_search": "Search team…",
  "project_search": "Search project…",
  "assignees_no_results": "No results",
  "create_success": "Task created",
  "description_placeholder": "Task details (optional)",
  "empty_no_assigned": "You have no tasks assigned.",
  "empty_create_first": "Create your first task",
  "filters": {
    "all": "All",
    "open": "Open",
    "completed": "Completed",
    "label": "Status",
    "period": "Period",
    "period_days": "Last {n} days",
    "period_all": "All time",
    "project_all": "All projects",
    "search_placeholder": "Search by name…",
    "no_results": "No tasks match these filters."
  },
  "groups": {
    "overdue": "Overdue",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "this_week": "This week",
    "upcoming": "Upcoming",
    "later": "Later",
    "no_date": "No date",
    "completed": "Completed"
  },
  "priority": {
    "urgent": "Urgent",
    "high": "High",
    "medium": "Medium",
    "low": "Low"
  },
  "board": {
    "unsorted": "Unsorted"
  },
  "empty": {
    "all": "No tasks assigned to you. Create one above or wait to be assigned.",
    "open": "No open tasks. All caught up!",
    "completed": "You haven't completed any tasks yet."
  },
  "name_max_reached": "You've reached the {n}-character limit for the title.",
  "field_extra_projects": "Also on these boards",
  "extra_projects_add": "+ Add board",
  "extra_projects_remove": "Remove {name}",
  "extra_projects_hint": "The task lives on the board above and also shows up on the ones you pick here.",
  "extra_projects_error": "The task was created, but it couldn't be added to the other boards.",
  "field_requester": "Requester",
  "requester_hint": "Who asked for this work (optional). Shown on the card.",
  "requester_name_placeholder": "Name",
  "requester_email_placeholder": "Email (optional)"
}
